import { subDays, addDays } from "date-fns";

const ExpenseGroupConfigs = {
  master: {
    title: "Expense Group",
    apiName: "masterdata/expensegroup",
    orderBy: "id",
    orderMethod: "ASC",
    additionalParams: { 
      // add_params
    },
  },
  dialog: {
    title: "Expense Group",
    isForm: false,
  },

  columns: [
    // add_configs
    {
      name: "Code",
      field: "code",
      type: "text_plain",
      table: true,
      filter: true,
      editor: true,
      object_name: "",
      object_field: "",
    },
    {
      name: "Name",
      field: "name",
      type: "text_plain",
      table: true,
      filter: true,
      editor: true,
      object_name: "",
      object_field: "",
    },
  ],
};

export default ExpenseGroupConfigs;
